const DuelSengit: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <h2 className="text-xl font-semibold mb-3">🤖 Duel Robot Sumo: Adu Kekuatan, Strategi, dan Kecepatan!</h2>

            <p className="mb-4">
                Suara sorak penonton, dentuman roda, dan gesekan logam menjadi latar dari pertarungan sengit di arena <span className="font-semibold text-gray-800">sumo robot</span>. Dalam kompetisi ini, dua robot otonom saling berhadapan, berusaha mendorong lawannya keluar dari arena melingkar layaknya pertarungan sumo sesungguhnya.
            </p>

            <p className="mb-4">
                Namun jangan salah, ini bukan sekadar dorong-dorongan biasa. Setiap robot dirancang dengan strategi dan teknologi yang matang:
            </p>

            <ul className="list-disc list-inside mb-4 space-y-2">
                <li><span className="font-semibold">Desain mekanik:</span> Rangka yang kuat, motor bertenaga, dan sensor posisi optimal.</li>
                <li><span className="font-semibold">Kecerdasan buatan:</span> Logika pengambilan keputusan otomatis untuk membaca posisi lawan dan menghindari jebakan.</li>
                <li><span className="font-semibold">Taktik tim:</span> Beberapa robot bermain agresif, sementara yang lain menunggu momentum untuk menyerang balik.</li>
            </ul>

            <blockquote className="border-l-4 pl-4 italic text-gray-600 mb-4">
                “Momen paling menegangkan adalah saat robot kecil tampak kalah… lalu tiba-tiba berhasil membalikkan keadaan dan mendorong lawannya keluar ring!”
            </blockquote>

            <p className="mb-4">
                Setiap pertarungan berlangsung cepat namun intens. Strategi bisa berubah dalam hitungan detik. Bahkan <span className="font-medium">satu kesalahan posisi atau pergerakan yang telat</span> bisa membuat sebuah robot kalah telak.
            </p>

            <p>
                Dengan kombinasi teknologi, kecepatan, dan adu strategi, <span className="font-semibold text-gray-800">sumo robot bukan hanya seru ditonton, tapi juga mencerminkan kemampuan teknik tinggi dari para pesertanya</span>. Tak heran jika setiap pertarungan selalu ditunggu-tunggu oleh para penonton.
            </p>
        </div>
    )
}
export default DuelSengit